import { IStore } from "../store";

export const prodottoSelector = (state: IStore) => state.prodotto;
